/**
 * ArticleText Functional Component
 * @Package - seo
 * @Author - SEO
 * @description: ArticleText for SEO pages used inside Article Component
 */

/**
 * ArticleText Component for SEO pages
 */

import React, { useCallback } from 'react'
import { Box, Paragraph } from '@usap/uicomponents'
import { Title } from '@usap/widgets'

// eslint-disable-next-line prefer-regex-literals
const H4EXP = new RegExp('<h4>(?<text>.*?)</h4>')
const style = {
  title: {
    fontSize: '18px',
  },
  paragraph: {
    fontSize: '16px',
    maxWidth: '720px',
    marginBlockStart: '0',
  },
}

export default function ArticleParagraph({
  data,
  prefArticleId,
  refs,
}) {
  const h4Arr = data.split(H4EXP)

  /**
   * Sanitize string before injecting to innerHTML
   * This would clean-up \" \' and other injection from the content
   *
   * @param {string} text
   * @return {string}
   */
  const sanitizeArticle = text => text.replace(/\\(?<quote>["'])/g, '$1')
  const getInnerHTML = useCallback(value => ({ __html: sanitizeArticle(value) }), [])

  return (
    <>
      {h4Arr.map((value, index) => {
        const oddIndex = index % 2 === 1
        const mapKey = `articleText-${value.length > 10 ? value.substring(0, 50) : value}`

        return oddIndex ? (
          <Box
            key={mapKey}
            ref={refs[`${prefArticleId + index}`]}
          >
            <Title
              id={prefArticleId + index}
              type="h4"
              title={value}
              style={style.title}
            />
          </Box>
        ) : (
          <Paragraph
            key={mapKey}
            style={style.paragraph}
            dangerouslySetInnerHTML={getInnerHTML(value)}
          />
        )
      })}
    </>
  )
}
